import { IOption } from  '@/interfaces/insightsp2';

const likes:IOption[] = [{
    value: "title",
    label: "Title"
},
{
    value: "channelTitle",
    label: "Channel"
},
{
    value: "widget",
    label: "Widget"
},
{
    value: "count",
    label: "Like"
}];

const comments:IOption[] = [{
    value: "title",
    label: "Title"
},
{
    value: "channelTitle",
    label: "Channel"
},
{
    value: "widget",
    label: "Widget"
},
{
    value: "count",
    label: "Comments"
}];

const contentViews:IOption[] = [{
    value: "title",
    label: "Title"
},
{
    value: "channelTitle",
    label: "Channel"
},
{
    value: "widget",
    label: "Widget"
},
{
    value: "count",
    label: "Total Views"
}];

const uniqueViews:IOption[] = [{
    value: "title",
    label: "Title"
},
{
    value: "channelTitle",
    label: "Channel"
},
{
    value: "widget",
    label: "Widget"
},
{
    value: "count",
    label: "Total Views"
}];

const competitionPosts:IOption[] = [{
    value: "title",
    label: "Title"
},
{
    value: "channelTitle",
    label: "Channel"
},
{
    value: "count",
    label: "Users Entered"
}];

const peopleThanked:IOption[] = [{
    value: "title",
    label: "Title"
},
{
    value: "channelTitle",
    label: "Channel"
}];

const ugc:IOption[] = [{
    value: "title",
    label: "Title"
},
{
    value: "channelTitle",
    label: "Channel"
}];

const fileDownloads:IOption[] = [{
    value: "title",
    label: "Title"
},
{
    value: "channelTitle",
    label: "Channel"
},
{
    value: "count",
    label: "Downloads"
}];

const video:IOption[] = [{
    value: "title",
    label: "Title"
},
{
    value: "channelTitle",
    label: "Channel"
},
{
    value: "count",
    label: "Plays"
}];

const mp3:IOption[] = [{
    value: "title",
    label: "Title"
},
{
    value: "channelTitle",
    label: "Channel"
},
{
    value: "count",
    label: "Plays"
}];

const compliance:IOption[] = [{
    value: "title",
    label: "Title"
},
{
    value: "channelTitle",
    label: "Channel"
},
{
    value: "count",
    label: "Users Responded"
}];

const events:IOption[] = [{
    value: "title",
    label: "Title"
},
{
    value: "channelTitle",
    label: "Channel"
},
{
    value: "count",
    label: "Users Attending"
}];

const sharedPosts:IOption[] = [{
    value: "title",
    label: "Title"
},
{
    value: "channelTitle",
    label: "Channel"
},
{
    value: "count",
    label: "Posts"
}];


export { 
    likes, 
    comments, 
    contentViews, 
    uniqueViews, 
    competitionPosts, 
    peopleThanked, 
    ugc, 
    fileDownloads,
    video,
    mp3,
    compliance,
    events,
    sharedPosts
}